import {
  startLoading,
  stopLoading,
} from '../../../common/modules/loading/actions'
import { LoadingTypes } from '../../../common/modules/loading/reducer'
import { updateAppAlert } from '../../../common/modules/appAlert/actions'
import {
  clearDraftProductCreationFail,
  clearDraftProductCreationSuccess,
  draftProductCreationFail,
  draftProductCreationSuccess,
  productCloneSuccess,
  productCreationSuccess,
  RequestFailureMessage,
} from '../../../common/utils/messagesContants'
import { AxiosError, AxiosResponse } from 'axios'
import { camelize, snakeize } from 'casing'
import { getErrorMessages } from '../../../common/utils/error'
import { errorLogger } from '../../../common/utils/errorLogger'
import { AppDispatch, RootState } from '../../../store'
import initialProduct from '../../../mocks/initialProduct.json'
import { get, isEmpty, isEqual, isNil } from 'common/utils/vanilla'
import { CloudType } from '../../../common/modules/types'
import {
  BuyerFormFieldsBackend,
  FlyoutProductAddEditSectionName,
  FlyoutProductSections,
  pageMarkerType,
  ContractDimension,
  FlyoutProductBuyerFormFields,
  ProductObjectDetail,
  NotificationRecipients,
  FlyoutListingProductType,
  FlyoutMicrosoftProductSections,
} from './reducer'
import {
  FlyOutAWSProductListingType,
  Product,
  ProductStatus,
} from '../productsListing/reducer'
import { FlyOutListingUserType } from '../../../admin/modules/flyOutSyncs/types'
import { convertRGBAAlpha } from '../../../common/utils/convertRGBAAlpha'
import { DateTime } from 'luxon'
import {
  putFlyOutProductFormData,
  getFlyOutProductFormData,
  getOtherProductDetails,
  patchFlyOutProductFormData,
  patchFlyOutProductSync,
} from '../../api/markeplace'
import { PlanType } from '@labrav/react-components'
import flyOutProductAgreementTerms from '../../../mocks/flyOutProductAgreementTerms.json'
import { getProductPageMarkerMapping } from '../../../common/utils/getPageMarkerMapping'
import {
  allFieldsArrayNotifications,
  autoSaveThresoldTime,
} from '../../../common/utils/constants'
import { v4 as uuidv4 } from 'uuid'
import { actionTypeWrapper } from '../../../common/utils/actionTypeWrapper'
import { clearProductsListing, getProducts } from '../productsListing/actions'
import { convertToKebabCase } from '../../../common/utils/convertToKebabCase'
import { isNonEmptyNumber } from '../../../common/utils/validateMinMax'
import { FlyoutOnboardingSectionName } from '../flyOutOnboarding/reducer'
import { EulaType } from '../privateOffer/reducer'
import { postMicrosoftProduct, postPublicProducts } from '../../api/azure'
import { setMigrationProductsData } from './productsInfo/action'
import { MigrationProduct } from './productsInfo/reducer'
import initialMSFTPoduct from '../../../mocks/initialMSFTPoduct.json'
export enum FlyoutProductForm {
  SET_FLYOUT_PRODUCT_FORM = 'SET_FLYOUT_PRODUCT_FORM',
  SET_FLYOUT_MICROSOFT_PRODUCT_FORM = 'SET_FLYOUT_MICROSOFT_PRODUCT_FORM',
  SET_FLYOUT_PRODUCT_DETAIL_FORM = 'SET_FLYOUT_PRODUCT_DETAIL_FORM',
  UPDATE_FLYOUT_PRODUCT_FORM = 'UPDATE_FLYOUT_PRODUCT_FORM',
  SET_FLYOUT_PRODUCT_LISTING_TYPE = 'SET_FLYOUT_PRODUCT_LISTING_TYPE',
  SET_ERROR_ON_FINAL_SUBMIT = 'SET_ERROR_ON_FINAL_SUBMIT',
  SET_CREATION_OTHER_INFO = 'SET_CREATION_OTHER_INFO',
  CLEAR_FLYOUT_PRODUCT_DETAIL_FORM = 'CLEAR_FLYOUT_PRODUCT_DETAIL_FORM',
  SET_DEFAULT_PRODUCT_INFO = 'SET_DEFAULT_PRODUCT_INFO',
}

const initialProductJson = { ...camelize(initialProduct) }

export const prePopulatedFieldLandingPage: Record<string, unknown> = {
  headingMessage: 'Welcome! Fill the information below to set up your account!',
  submissionSuccessMessage:
    'Thank you for completing the form. You will now be redirected to signup page.',
  emailCustomMessage:
    'Thank you for subscribing, we hope you enjoy using our product. If you have any questions, feel free to contact our customer support team!',
  existingBuyerMessage:
    'You are already a registered user in our system. Redirecting you to our login page.',
  existingBuyerRedirectSeconds: 5,
  redirectSeconds: 5,
}

export const PRODUCT_DIMENSIONS_ZERO_VALUE = {
  name: '',
  label: '',
  price: null,
  price1m: null,
  price12m: null,
  price24m: null,
  price36m: null,
  additionalUsagePrice: null,
  subscriptionPrice: null,
  labelDescription: '',
  isAdditionalUsageAllowed: false,
  additionalUsageDescription: '',
}

const getInitialProductBasedOnCloud = (
  cloudType: CloudType,
  awsProductType?: FlyOutAWSProductListingType,
  listingType?: FlyoutListingProductType,
  initialProductLogo?: string,
  isIndiaRegistered?: boolean
) => {
  switch (cloudType) {
    case 'AWS': {
      return {
        ...initialProductJson,
        productDetails: {
          ...initialProductJson.productDetails,
          ...(awsProductType === FlyOutAWSProductListingType.SAAS
            ? { productType: PlanType.SAAS_CONTRACT }
            : {}),
          ...(listingType === FlyoutListingProductType.MIGRATED
            ? { productType: PlanType.SAAS_CONTRACT }
            : {}),
          listingType: listingType,
        },
        generalInformation: {
          ...initialProductJson.generalInformation,
          productLogoUrl: initialProductLogo,
          ...(awsProductType === FlyOutAWSProductListingType.AGENTIC_AI
            ? { isAgenticProduct: true }
            : {}),
          ...(isIndiaRegistered
            ? {
                includedCountries: ['India'],
                countriesSelected: ['India'],
                countryAvailability: 'includedCountries',
              }
            : {}),
        },
      }
    }
    case 'AZURE': {
      return {
        ...initialMSFTPoduct,
      }
    }
    case 'GCP': {
      return {}
    }
    case 'REDHAT': {
      return {}
    }
  }
}

type GetProductInCreationArgs = {
  partnerId: string
  cloudType: CloudType
  productId?: string
  awsProductType?: FlyOutAWSProductListingType
  listingType: FlyoutListingProductType
  isDefault?: boolean
  isFreeTrialProductEnable?: boolean
}

type GetProductInCloneArgs = {
  partnerId: string
  cloudType: CloudType
  productId?: string
  awsProductType?: FlyOutAWSProductListingType
  listingType: FlyOutListingUserType
  callBackFlyoutProduct?: (productId: string) => void
  isDraftListing?: boolean
  isFreeTrialProductEnable?: boolean
}

export const getProductInCreation =
  ({
    partnerId,
    cloudType,
    productId,
    awsProductType,
    listingType,
    isFreeTrialProductEnable = false,
  }: GetProductInCreationArgs) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    await dispatch(startLoading(LoadingTypes.FLYOUT_PRODUCT_DETAIL))
    try {
      if (isEmpty(productId)) {
        const productDefaultInfo =
          getState().flyoutProductInCreation?.productDefaultInfo
        const initialProductLogo =
          getState().flyOutOnboarding?.onboardingForm[
            FlyoutOnboardingSectionName?.GENERAL_INFORMATION
          ]?.logoUrl || ''

        const isIndiaRegistered =
          cloudType === 'AWS' &&
          getState().flyOutOnboarding?.onboardingForm[
            FlyoutOnboardingSectionName?.CLOUD_SETTINGS
          ]?.countryRegistered === 'IN'

        const initialProduct = getInitialProductBasedOnCloud(
          cloudType,
          awsProductType,
          listingType,
          initialProductLogo,
          isIndiaRegistered
        )
        const updatedInitialValue = { ...initialProduct }
        updatedInitialValue.productDimensions = {
          ...updatedInitialValue.productDimensions,
          ...(isFreeTrialProductEnable
            ? { freeTrial: { isEnable: false } }
            : {}),
        }
        await dispatch(setProductFormListingType(listingType))
        await dispatch(setOtherProductInfo({ error: '', updatedAt: undefined }))
        await dispatch(
          setProductFormData({
            ...initialProduct,
            ...(productDefaultInfo ? productDefaultInfo : {}),
          })
        )
      } else {
        const response = await getFlyOutProductFormData({
          partnerId,
          productId,
        })
        if (response) {
          const camelizedProductData = JSON.parse(
            JSON.stringify(get(camelize(response), 'data') || {}).replaceAll(
              '\\\\"',
              '"'
            )
          )
          const transformedProduct = await transformGetProductData({
            flyoutProductData: camelizedProductData.detailsJson,
            lockMetadata: camelizedProductData.lockMetadata,
          })
          const user = getState().userProfile
          const pageMarkerMapping: Record<string, string> =
            getProductPageMarkerMapping(false)
          const timeDiff = Math.ceil(
            DateTime.now().diff(
              transformedProduct?.lockMetadata?.lastActivityAt
                ? DateTime.fromISO(
                    transformedProduct?.lockMetadata?.lastActivityAt
                  )
                : DateTime.now(),
              ['seconds']
            ).seconds
          )
          if (
            timeDiff > autoSaveThresoldTime ||
            isEmpty(transformedProduct?.lockMetadata?.lastActivityAt)
          ) {
            const newWindowId = uuidv4()
            window.name = newWindowId
            transformedProduct.lockMetadata = {
              ...transformedProduct.lockMetadata,
              windowId: newWindowId,
              lockedBy: user.userProfile.id,
              lockedByName:
                `${user.userProfile.firstName || ''} ${user.userProfile.lastName || ''}`.trim(),
              lockByEmail: user.userProfile.email,
              lockAcquisitionProbe: true,
            }
            await dispatch(
              sendFlyoutProduct({
                partnerId,
                isAutoSave: true,
                productForm: transformedProduct,
                pageMarkerMapping,
                page: FlyoutProductAddEditSectionName.NOTIFICATIONS_RECIPIENTS,
                productId,
                status: 'lockAcquire',
              })
            )
          } else {
            await dispatch(
              setOtherProductInfo({
                error: camelizedProductData?.error,
                updatedAt: camelizedProductData?.updatedAt,
              })
            )
            await dispatch(setProductFormData(transformedProduct))
          }
        }
      }
    } catch (error) {
      await dispatch(
        updateAppAlert({
          message: getErrorMessages([RequestFailureMessage])(
            error as AxiosResponse<ErrorResponse>
          ),
          messageType: 'ERROR',
          autoClose: false,
        })
      )
      const globalState = getState()
      errorLogger({ globalState })(error as Error)
    } finally {
      await dispatch(stopLoading(LoadingTypes.FLYOUT_PRODUCT_DETAIL))
    }
  }

type GetProductIDForOtherProductArgs = {
  partnerId: string
  listingLink: string
}

export const getProductIDForOtherProduct = async ({
  partnerId,
  listingLink,
}: GetProductIDForOtherProductArgs): Promise<string | undefined> => {
  try {
    const response = await getOtherProductDetails({
      partnerId,
      listingLink,
    })

    if (response) {
      const productId = response.data.id || ''
      return productId
    } else {
      console.warn('No product details found')
      return undefined
    }
  } catch (error) {
    console.error('Error fetching product ID:', error)
    return undefined
  }
}

interface GetProductDetailsArgs {
  partnerId: string
  productId?: string
  isDefault?: boolean
}

export const getProductDetail =
  ({ partnerId, productId, isDefault }: GetProductDetailsArgs) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    if (!isDefault) {
      await dispatch(clearProductDetail())
    }
    await dispatch(startLoading(LoadingTypes.FLYOUT_PRODUCT_DETAIL))
    try {
      const response = await getFlyOutProductFormData({
        partnerId,
        productId,
        editPage: true,
      })
      if (response) {
        const responseData = get(response, 'data')
        const camelizedProductDetailData = JSON.parse(
          JSON.stringify(camelize(responseData)).replaceAll('\\\\"', '"')
        )
        if (!isEmpty(camelizedProductDetailData)) {
          const productDetail = {
            generalInformation: {
              ...camelizedProductDetailData?.generalInformation,
            },
            notificationRecipients: {
              ...camelizedProductDetailData?.notificationRecipients,
            },
            infoCollectionFormMetaData: {
              ...camelizedProductDetailData?.infoCollectionFormMetaData,
            },
            productDimensions: {
              ...camelizedProductDetailData?.productDimensions,
            },
            buyerFormFields: {
              ...camelizedProductDetailData?.buyerFormFields,
            },
            productDetails: {
              productType: camelizedProductDetailData?.productType,
              productName: camelizedProductDetailData?.productName,
            },
          }
          const transformedProductDetail = await transformGetProductData({
            flyoutProductData: productDetail,
            isEdit: true,
          })
          const updatedProduct = getUpdatedEmptyData(transformedProductDetail)
          const status = camelizedProductDetailData?.status
          const auditJson = responseData?.audit_json || {}
          const productName = camelizedProductDetailData?.productName
          if (!isDefault) {
            await dispatch(
              setProductDetailFormData({
                productForm: updatedProduct,
                status: status,
                auditJson: auditJson,
                productName: productName,
                marketplaceUrl: camelizedProductDetailData?.marketplaceUrl,
                edit: camelizedProductDetailData?.edit,
                awsChangeSetStatus: responseData?.aws_change_set_status,
                error: responseData?.error,
                productType: responseData?.product_type,
                updatedAt: response?.data?.updated_at,
              })
            )
          } else {
            await dispatch(
              setProductDefaultInfo({
                [FlyoutProductAddEditSectionName.LANDING_PAGE_DETAILS]:
                  updatedProduct?.infoCollectionFormMetaData,
                [FlyoutProductAddEditSectionName.NOTIFICATIONS_RECIPIENTS]:
                  updatedProduct?.notificationRecipients,
              })
            )
          }
        }
      }
    } catch (error) {
      await dispatch(
        updateAppAlert({
          message: getErrorMessages([RequestFailureMessage])(
            error as AxiosResponse<ErrorResponse>
          ),
          messageType: 'ERROR',
          autoClose: false,
        })
      )
      const globalState = getState()
      errorLogger({ globalState })(error as Error)
    } finally {
      await dispatch(stopLoading(LoadingTypes.FLYOUT_PRODUCT_DETAIL))
    }
  }

export const getUpdatedEmptyData = (transformedProductDetail: any) => {
  const {
    highlights,
    resourceUrls,
    excludedCountries,
    includedCountries,
    countriesSelected,
  } = transformedProductDetail?.generalInformation
  const notificationRecipients =
    transformedProductDetail?.notificationRecipients
  let updatedNotificationRecipients = {}
  allFieldsArrayNotifications.forEach(keyName => {
    updatedNotificationRecipients = {
      ...updatedNotificationRecipients,
      [keyName]:
        notificationRecipients[
          keyName as string as keyof NotificationRecipients
        ] || [],
    }
  })
  return {
    ...transformedProductDetail,
    generalInformation: {
      ...transformedProductDetail?.generalInformation,
      highlights: highlights || [],
      resourceUrls: resourceUrls || [],
      excludedCountries: excludedCountries || [],
      includedCountries: includedCountries || [],
      countriesSelected: countriesSelected || [],
    },
    notificationRecipients: {
      ...updatedNotificationRecipients,
    },
  }
}

export const getProductCloneDetail =
  ({
    partnerId,
    productId,
    callBackFlyoutProduct,
    isDraftListing,
    isFreeTrialProductEnable,
  }: GetProductInCloneArgs) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    await dispatch(startLoading(LoadingTypes.FLYOUT_PRODUCT_DETAIL))
    try {
      const response = await getFlyOutProductFormData({
        partnerId,
        productId,
        ...(isDraftListing ? {} : { editPage: true }),
      })
      if (!isDraftListing) {
        if (response) {
          const responseData = get(response, 'data')
          const camelizedProductDetailData = JSON.parse(
            JSON.stringify(camelize(responseData)).replaceAll('\\\\"', '"')
          )
          if (!isEmpty(camelizedProductDetailData)) {
            const productDetail = {
              generalInformation: {
                ...camelizedProductDetailData?.generalInformation,
              },
              notificationRecipients: {
                ...camelizedProductDetailData?.notificationRecipients,
              },
              infoCollectionFormMetaData: {
                ...camelizedProductDetailData?.infoCollectionFormMetaData,
              },

              productDimensions: {
                ...camelizedProductDetailData?.productDimensions,
                dimensions:
                  camelizedProductDetailData?.productDimensions?.dimensions?.map(
                    ({ id, ...rest }: any) => ({ ...rest })
                  ),
                ...(isFreeTrialProductEnable
                  ? { freeTrial: { isEnable: false } }
                  : {}),
              },
              buyerFormFields: {
                ...camelizedProductDetailData?.buyerFormFields,
              },
              productDetails: {
                productType: camelizedProductDetailData?.productType,
                productName: camelizedProductDetailData?.productName,
                listingType: 'NEW',
              },
              migrationDetails: {
                products: [],
              },
              completed: {
                value: false,
              },
              page_marker: {
                page1: false,
                page2: false,
                page3: false,
                page4: false,
              },
              terms_and_conditions: {
                ...initialProduct.terms_and_conditions,
              },
              agreement: {
                ...initialProduct.agreement,
              },
            }
            productDetail.generalInformation.title = `(Clone) ${productDetail?.generalInformation?.title}`
            productDetail.productDetails.productName = `(Clone) ${productDetail.productDetails.productName}`
            const transformedProductDetail = await transformGetProductData({
              flyoutProductData: productDetail,
              isEdit: true,
            })
            const updatedProduct = getUpdatedEmptyData(transformedProductDetail)
            const user = getState().userProfile

            const pageMarkerMapping: Record<string, string> =
              getProductPageMarkerMapping(false)

            const newWindowId = uuidv4()
            window.name = newWindowId
            updatedProduct.lockMetadata = {
              ...updatedProduct.lockMetadata,
              windowId: newWindowId,
              lockedBy: user.userProfile.id,
              lockedByName:
                `${user.userProfile.firstName || ''} ${user.userProfile.lastName || ''}`.trim(),
              lockByEmail: user.userProfile.email,
              lockAcquisitionProbe: true,
            }
            await dispatch(
              sendFlyoutProduct({
                partnerId,
                isAutoSave: true,
                productForm: updatedProduct,
                pageMarkerMapping,
                page: FlyoutProductAddEditSectionName.NOTIFICATIONS_RECIPIENTS,
                status: 'lockAcquire',
                cloneproduct: true,
                callBackFlyoutProduct,
              })
            )
          }
        }
      } else {
        if (response) {
          const camelizedProductData = JSON.parse(
            JSON.stringify(get(camelize(response), 'data') || {}).replaceAll(
              '\\\\"',
              '"'
            )
          )
          const transformedProduct = await transformGetProductData({
            flyoutProductData: camelizedProductData.detailsJson,
            lockMetadata: camelizedProductData.lockMetadata,
          })
          transformedProduct.generalInformation.title = `(Clone) ${transformedProduct?.generalInformation?.title}`
          transformedProduct.productDetails.productName = `(Clone) ${transformedProduct.productDetails.productName}`
          transformedProduct.productDetails.productDimensions = {
            ...transformedProduct.productDetails.productDimensions,
            ...(isFreeTrialProductEnable
              ? { freeTrial: { isEnable: false } }
              : {}),
          }
          const user = getState().userProfile
          const pageMarkerMapping: Record<string, string> =
            getProductPageMarkerMapping(false)
          const newWindowId = uuidv4()
          window.name = newWindowId
          transformedProduct.lockMetadata = {
            ...transformedProduct.lockMetadata,
            windowId: newWindowId,
            lockedBy: user.userProfile.id,
            lockedByName: `${user.userProfile.firstName} ${user.userProfile.lastName}`,
            lockByEmail: user.userProfile.email,
            lockAcquisitionProbe: true,
          }
          await dispatch(
            sendFlyoutProduct({
              partnerId,
              isAutoSave: true,
              productForm: transformedProduct,
              pageMarkerMapping,
              page: FlyoutProductAddEditSectionName.NOTIFICATIONS_RECIPIENTS,
              status: 'lockAcquire',
              cloneproduct: true,
              callBackFlyoutProduct,
            })
          )
        }
      }
    } catch (error) {
      await dispatch(
        updateAppAlert({
          message: getErrorMessages([RequestFailureMessage])(
            error as AxiosResponse<ErrorResponse>
          ),
          messageType: 'ERROR',
          autoClose: false,
        })
      )
      const globalState = getState()
      errorLogger({ globalState })(error as Error)
    } finally {
      await dispatch(stopLoading(LoadingTypes.FLYOUT_PRODUCT_DETAIL))
    }
  }

export const setProductFormData = (
  productFormData: Record<string, unknown>
) => ({
  type: FlyoutProductForm.SET_FLYOUT_PRODUCT_FORM,
  payload: productFormData,
})

export const setMicrosoftProductFormData = (
  productFormData: Record<string, unknown>
) => ({
  type: FlyoutProductForm.SET_FLYOUT_MICROSOFT_PRODUCT_FORM,
  payload: productFormData,
})

export const setProductDefaultInfo = (
  productDefaultInfo: Record<string, unknown>
) => ({
  type: FlyoutProductForm.SET_DEFAULT_PRODUCT_INFO,
  payload: productDefaultInfo,
})

export const setProductDetailFormData = (
  productDetailFormData: ProductObjectDetail
) => ({
  type: FlyoutProductForm.SET_FLYOUT_PRODUCT_DETAIL_FORM,
  payload: productDetailFormData,
})
export type FlyOutProductFormChangeType = {
  sectionName: FlyoutProductAddEditSectionName
  keyName: string
  value: string | boolean
}
export const updateProductFormData = (data: FlyOutProductFormChangeType) => ({
  type: FlyoutProductForm.UPDATE_FLYOUT_PRODUCT_FORM,
  payload: data,
})
export const setProductFormListingType = (type: FlyoutListingProductType) => ({
  type: FlyoutProductForm.SET_FLYOUT_PRODUCT_LISTING_TYPE,
  payload: type,
})
export const setErrorOnFinalSubmit = (data: string) => ({
  type: FlyoutProductForm.SET_ERROR_ON_FINAL_SUBMIT,
  payload: data,
})

export const setOtherProductInfo = (
  productOtherInfo: Record<string, unknown>
) => ({
  type: FlyoutProductForm.SET_CREATION_OTHER_INFO,
  payload: productOtherInfo,
})

interface SendFlyoutProductProps {
  isAutoSave: boolean
  productForm: FlyoutProductSections
  pageMarkerMapping: Record<string, string>
  page: FlyoutProductAddEditSectionName
  partnerId: string
  productId?: string
  status?: string
  callBackFlyoutProduct?: (productId: string) => void
  isClear?: boolean
  redirectToListing?: () => void
  cloneproduct?: boolean
  switchLandingPage?: boolean
  isSinglePageFinalSubmit?: boolean
}

const returnTrimedValue = (value?: string) => {
  if (!value) return ''
  return value?.trim().replace(/[\r\n]+/gm, ' ')
}

const objectValueTrim = (
  objectTobeTrimed: Record<string, string | undefined>,
  specificKeys?: string[]
) => {
  return (specificKeys || Object.keys(objectTobeTrimed)).reduce<
    Record<string, string | undefined>
  >((acc, curr) => {
    acc[curr] =
      typeof objectTobeTrimed[curr] === 'string'
        ? returnTrimedValue(objectTobeTrimed[curr])
        : objectTobeTrimed[curr]
    return acc
  }, {})
}

const arrayFieldValueTrim = (
  arrayToBeTrimed: Record<string, any | undefined>[],
  fieldKeys: string[]
) => {
  return arrayToBeTrimed.map(arrayItem => ({
    ...arrayItem,
    ...objectValueTrim(
      {
        ...arrayItem,
      },
      fieldKeys
    ),
  }))
}

export const stringArrayValueTrim = (arrayToBeTrimed: string[]) => {
  return arrayToBeTrimed?.map(item => returnTrimedValue(item))
}

export const getTrimedValueProductForm = (
  productForm: FlyoutProductSections
) => {
  const {
    generalInformation,
    infoCollectionFormMetaData,
    productDetails,
    productDimensions,
  } = productForm
  const {
    sku,
    shortProductDescription,
    productDescription,
    supportResources,
    refundPolicy,
    title,
    companyName,
    resourceUrls,
    highlights,
    productVideoLink,
    saasUrl,
  } = generalInformation
  const {
    redirectUrl,
    submissionSuccessMessage,
    headingMessage,
    privacyPolicyLink,
    emailCustomMessage,
    existingBuyerMessage,
    existingBuyerRedirectUrl,
    buyerFormFields,
    redirectionSettings,
  } = infoCollectionFormMetaData
  const { productName } = productDetails
  const { dimensions, additionalDimensions } = productDimensions
  const {
    applicationLoginPageUrl,
    customInstructions,
    demoDocumentUrl,
    demoVideoUrl,
    testingCredentials,
  } = redirectionSettings
  return {
    ...productForm,
    generalInformation: {
      ...generalInformation,
      ...objectValueTrim({
        sku,
        shortProductDescription,
        productDescription,
        supportResources,
        refundPolicy,
        title,
        companyName,
        productVideoLink,
        saasUrl,
      }),
      resourceUrls: arrayFieldValueTrim(resourceUrls, ['Text', 'Url']),
      highlights: stringArrayValueTrim(highlights),
    },
    infoCollectionFormMetaData: {
      ...infoCollectionFormMetaData,
      ...objectValueTrim({
        redirectUrl,
        submissionSuccessMessage,
        headingMessage,
        privacyPolicyLink,
        emailCustomMessage,
        existingBuyerMessage,
        existingBuyerRedirectUrl,
      }),
      buyerFormFields: arrayFieldValueTrim(buyerFormFields || [], ['title']),
      redirectionSettings: {
        ...redirectionSettings,
        ...objectValueTrim({
          applicationLoginPageUrl,
          customInstructions,
          demoDocumentUrl,
          demoVideoUrl,
        }),
        testingCredentials: {
          ...testingCredentials,
          ...objectValueTrim({
            ...testingCredentials,
          }),
        },
      },
    },
    productDetails: {
      ...productDetails,
      ...objectValueTrim({
        productName,
      }),
    },
    productDimensions: {
      ...productDimensions,
      dimensions: arrayFieldValueTrim(dimensions, [
        'name',
        'label',
        'labelDescription',
        'additionalUsageDescription',
      ]),
      additionalDimensions: arrayFieldValueTrim(additionalDimensions || [], [
        'name',
        'label',
        'labelDescription',
        'additionalUsageDescription',
      ]),
    },
  } as FlyoutProductSections
}

export const sendFlyoutProduct =
  ({
    partnerId,
    isAutoSave,
    productForm,
    pageMarkerMapping,
    page,
    productId,
    status,
    callBackFlyoutProduct,
    isClear,
    redirectToListing,
    cloneproduct,
    switchLandingPage,
    isSinglePageFinalSubmit = false,
  }: SendFlyoutProductProps) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    try {
      !isAutoSave &&
        (await dispatch(
          startLoading(LoadingTypes.SUBMIT_FLYOUT_PRODUCT_DETAIL)
        ))
      const getProductStateData =
        getState()?.flyoutProductInCreation.currentProductInCreation.productForm
      const isFormUpdated = isChangeInProductData(
        productForm,
        getProductStateData
      )
      const productFormData = getTrimedValueProductForm(productForm)
      const sendProductPayload = processFlyoutProduct({
        productForm: productFormData,
        isAutoSave,
        pageMarkerMapping,
        page,
        isFormUpdated,
        status,
        productId,
        isSinglePageFinalSubmit,
      })
      const productPayload = JSON.parse(
        JSON.stringify(sendProductPayload).replaceAll('\\"', '\\\\\\"')
      )

      const response = await putFlyOutProductFormData({
        data: productPayload,
        partnerId,
        productId,
        switchLandingPage,
      })
      if (response) {
        const camelizedProductData = JSON.parse(
          JSON.stringify(get(camelize(response), 'data') || {}).replaceAll(
            '\\\\"',
            '"'
          )
        )
        const transformedProduct = await transformGetProductData({
          flyoutProductData: camelizedProductData.detailsJson,
          lockMetadata: camelizedProductData.lockMetadata,
        })
        await dispatch(
          setOtherProductInfo({
            error: camelizedProductData?.error,
            updatedAt: camelizedProductData?.updatedAt,
          })
        )
        await dispatch(setProductFormData(transformedProduct))

        const successMessage = cloneproduct
          ? productCloneSuccess
          : transformedProduct?.completed?.value
            ? productCreationSuccess
            : draftProductCreationSuccess
        if (!isAutoSave || (isAutoSave && isClear) || cloneproduct) {
          await dispatch(
            updateAppAlert({
              message: isClear
                ? clearDraftProductCreationSuccess
                : successMessage,
              messageType: 'SUCCESS',
              autoClose: true,
            })
          )
        }
        if (transformedProduct?.completed?.value && redirectToListing) {
          await dispatch(
            actionTypeWrapper(CloudType.AWS, clearProductsListing())
          )
          await dispatch(getProducts(partnerId, CloudType.AWS))
          await redirectToListing()
        }
      }

      if (
        (isEmpty(productId) || status === 'lockAcquire') &&
        response &&
        callBackFlyoutProduct &&
        !isSinglePageFinalSubmit
      ) {
        await callBackFlyoutProduct(response.data.id)
      }
    } catch (error: any) {
      const allOtherPageMarkersTrue = getAllOtherPageMarkersTrue({
        sectionName: page,
        pageMarkerMapping,
        pageMarker: productForm[FlyoutProductAddEditSectionName.PAGE_MARKER],
        isMigrated:
          productForm[FlyoutProductAddEditSectionName.CLOUD_PRODUCT_DETAILS]
            .listingType === FlyoutListingProductType.MIGRATED,
      })
      if (!isAutoSave && allOtherPageMarkersTrue) {
        const errorMessage = getErrorMessages(['error Occured '])(
          error.response as AxiosResponse<ErrorResponse>
        )
        await dispatch(setErrorOnFinalSubmit(errorMessage))
      }
      if (!isAutoSave) {
        const errMessage: string = isClear
          ? clearDraftProductCreationFail
          : draftProductCreationFail
        const errorMessage = getErrorMessages([errMessage])(
          error.response as AxiosResponse<ErrorResponse>
        )

        await dispatch(stopLoading(LoadingTypes.SUBMIT_FLYOUT_PRODUCT_DETAIL))
        if (isEmpty(status)) {
          await dispatch(
            updateAppAlert({
              message: errorMessage,
              messageType: 'ERROR',
              autoClose: false,
            })
          )
        }
        const e = error as AxiosError
        const errorResponse = e?.response as AxiosResponse<ErrorResponse>

        dispatch(
          updateAppAlert({
            message: getErrorMessages([RequestFailureMessage])(errorResponse),
            messageType: 'ERROR',
            autoClose: true,
          })
        )
        const globalState = getState()
        errorLogger({ globalState })(
          error as Error,
          errorResponse?.data?.track_id
        )
      } else {
        return error
      }
    } finally {
      !isAutoSave &&
        (await dispatch(stopLoading(LoadingTypes.SUBMIT_FLYOUT_PRODUCT_DETAIL)))
    }
  }

export const processFlyoutProduct = ({
  productForm,
  isAutoSave,
  pageMarkerMapping,
  page,
  isFormUpdated,
  status,
  productId,
  isEdit,
  existingBuyerFormField,
  isSinglePageFinalSubmit,
}: {
  productForm: FlyoutProductSections
  isAutoSave?: boolean
  pageMarkerMapping?: Record<string, string>
  page?: FlyoutProductAddEditSectionName
  isFormUpdated?: boolean
  status?: string
  productId?: string
  isEdit?: boolean
  existingBuyerFormField?: Record<string, BuyerFormFieldsBackend>
  isSinglePageFinalSubmit?: boolean
}) => {
  const {
    bgColor,
    buttonColor,
    buttonTextColor,
    buyerFormFields,
    ...restInfoCollectionData
  } = productForm[FlyoutProductAddEditSectionName.LANDING_PAGE_DETAILS]

  const { dimensions, additionalDimensions, ...restProductDimensions } =
    productForm[FlyoutProductAddEditSectionName.PRODUCT_DIMENSIONS]

  const updatedSupportResources =
    productForm.generalInformation?.resourceUrls?.filter(
      (resource: any) => resource.Text !== '' && resource.Url !== ''
    )

  const updatedDimensions = dimensions
    .filter((dimension: any) => dimension.name !== '')
    .map((dimension: any) => {
      const { checkBoxAdditionalUsageAllowed, ...updatedDimension } = dimension
      return {
        ...updatedDimension,
      }
    })

  const updatedAdditionalDimensions = (additionalDimensions || []).map(
    (dimension: any) => {
      const {
        id,
        checkBoxAdditionalUsageAllowed,
        ...aditionalDimensionsUpdated
      } = dimension
      return {
        ...aditionalDimensionsUpdated,
        ...(isEdit && id ? { id: id } : {}),
      }
    }
  )

  const transformedBuyerField = buyerFormFields?.reduce(
    (acc, field, index) => {
      const {
        title,
        displayOrder,
        dataType,
        isRequired,
        validationType,
        minLength,
        maxLength,
        id,
      } = field

      const initialLength = existingBuyerFormField
        ? Object.values(existingBuyerFormField).filter(item => !item.isCustom)
            .length
        : 3
      const formatTitle = returnTrimedValue(title).toLowerCase()
      const key = camelize(formatTitle.replace(/ /g, '_'))
      acc[key] = {
        title: formatTitle,
        displayOrder: initialLength + index + 1,
        placeHolder: formatTitle,
        dataType,
        isCustom: true,
        isRequired,
        validationType,
        maxLength,
        minLength,
        ...(isEdit && id ? { id: id, displayOrder: displayOrder } : {}),
      }
      return acc
    },
    {} as Record<string, BuyerFormFieldsBackend>
  )

  const allOtherPageMarkersTrue =
    isSinglePageFinalSubmit ||
    (page &&
      pageMarkerMapping &&
      getAllOtherPageMarkersTrue({
        sectionName: page,
        pageMarkerMapping,
        pageMarker: productForm[FlyoutProductAddEditSectionName.PAGE_MARKER],
        isMigrated:
          productForm[FlyoutProductAddEditSectionName.CLOUD_PRODUCT_DETAILS]
            .listingType === FlyoutListingProductType.MIGRATED,
      }))

  const camelizeProductData = {
    ...productForm,
    generalInformation: {
      ...productForm.generalInformation,
      resourceUrls: updatedSupportResources,
      ...(isEdit &&
      productForm?.[FlyoutProductAddEditSectionName.GENERAL_INFORMATION]
        .eula === EulaType.STANDARD
        ? { eulaUrl: '' }
        : {}),
    },
    infoCollectionFormMetaData: {
      ...restInfoCollectionData,
      bgColor: convertRGBAAlpha(bgColor, true),
      buttonColor: convertRGBAAlpha(buttonColor, true),
      buttonTextColor: convertRGBAAlpha(buttonTextColor, true),
    },
    buyerFormFields: {
      ...(!isEdit
        ? initialProductJson.buyerFormFields
        : existingBuyerFormField),
      ...transformedBuyerField,
    },
    productDimensions: {
      ...restProductDimensions,
      dimensions: [...updatedDimensions, ...updatedAdditionalDimensions],
    },
    ...(!isEdit
      ? {
          lockMetadata: {
            ...productForm.lockMetadata,
            ...(isFormUpdated || status === 'lockAcquire' || isEmpty(productId)
              ? { lastActivityAt: DateTime.now().toUTC().toISO() }
              : {}),
            editingEnabled: status === 'lockAcquire' || isEmpty(productId),
          },
          ...(!isAutoSave &&
            pageMarkerMapping &&
            page && {
              pageMarker: {
                ...productForm.pageMarker,
                [camelize(pageMarkerMapping[page])]: true,
              },
              completed: {
                value: allOtherPageMarkersTrue,
              },
            }),
        }
      : {}),
  }

  const { productDimensions, generalInformation, notificationRecipients } =
    camelizeProductData

  let updatedNotificationRecipients = {}
  Object.keys(notificationRecipients).forEach(keyName => {
    const kebabCaseKeyName = convertToKebabCase(keyName)
    updatedNotificationRecipients = {
      ...updatedNotificationRecipients,
      [kebabCaseKeyName]:
        notificationRecipients[
          keyName as string as keyof NotificationRecipients
        ],
    }
  })

  const snakeizeDimensions = productDimensions?.dimensions
    ? productDimensions?.dimensions.map((dimension: any) => {
        const {
          price1m,
          price12m,
          price24m,
          price36m,
          isExisting,
          ...restProps
        } = dimension

        const priceObj = isEdit
          ? {
              ...(isNonEmptyNumber(price1m) ? { price_1m: price1m } : {}),
              ...(isNonEmptyNumber(price12m) ? { price_12m: price12m } : {}),
              ...(isNonEmptyNumber(price24m) ? { price_24m: price24m } : {}),
              ...(isNonEmptyNumber(price36m) ? { price_36m: price36m } : {}),
            }
          : {
              price_1m: price1m || null,
              price_12m: price12m || null,
              price_24m: price24m || null,
              price_36m: price36m || null,
            }
        return {
          ...snakeize(restProps),
          ...priceObj,
        }
      })
    : []

  const updatedResourceUrls = generalInformation.resourceUrls
    ? generalInformation.resourceUrls.map((resources: any) => {
        const { Text, Url } = resources
        return {
          Text: Text,
          Url: Url,
        }
      })
    : []
  const snakeizeProductInfo = { ...snakeize(camelizeProductData) }
  return {
    ...snakeizeProductInfo,
    product_dimensions: {
      ...snakeize(productDimensions),
      dimensions: snakeizeDimensions,
    },
    general_information: {
      ...snakeizeProductInfo.general_information,
      resource_urls: updatedResourceUrls,
    },
    notification_recipients: {
      ...updatedNotificationRecipients,
    },
  }
}

export const getAllOtherPageMarkersTrue = ({
  pageMarker,
  pageMarkerMapping,
  sectionName,
  isMigrated,
}: {
  pageMarker?: pageMarkerType
  pageMarkerMapping: Record<string, string>
  sectionName: FlyoutProductAddEditSectionName
  isMigrated: boolean
  isHostWithLabra?: boolean
}) =>
  (pageMarker ? Object.keys(pageMarker) : []).every(marker => {
    const currentSectionPageMarker = camelize(pageMarkerMapping[sectionName])

    if (isMigrated) {
      return marker !== currentSectionPageMarker && marker !== 'page2'
        ? pageMarker && pageMarker[marker]
        : true
    }

    return marker !== currentSectionPageMarker
      ? pageMarker && pageMarker[marker]
      : true
  })

export const isChangeInProductData = (
  productData: FlyoutProductSections,
  getProductStateData: FlyoutProductSections
) => {
  const { lockMetadata: metaData, ...restProductData } = productData
  const { lockMetadata, ...restGetProductStateData } = getProductStateData
  return !isEqual(restProductData, restGetProductStateData)
}

export const transformGetProductData = async ({
  flyoutProductData,
  lockMetadata,
  isEdit,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  flyoutProductData: any
  lockMetadata?: any
  isEdit?: boolean
}) => {
  const { buyerFormFields = {} } = flyoutProductData
  const excludedFields = ['email', 'firstName', 'companyName']
  const customFields = Object.keys(buyerFormFields || {})
    .filter(
      fieldName =>
        typeof buyerFormFields[fieldName] === 'object' &&
        buyerFormFields[fieldName] !== null &&
        !excludedFields.includes(fieldName) &&
        buyerFormFields[fieldName]?.isCustom
    )
    .map(fieldName => {
      const typedFieldInfo = buyerFormFields[
        fieldName
      ] as FlyoutProductBuyerFormFields
      return {
        title: typedFieldInfo?.title,
        displayOrder: typedFieldInfo?.displayOrder,
        dataType: typedFieldInfo?.dataType,
        isRequired: typedFieldInfo?.isRequired,
        validationType: typedFieldInfo?.validationType,
        minLength: typedFieldInfo?.minLength,
        maxLength: typedFieldInfo?.maxLength,
        ...(typedFieldInfo?.id ? { id: typedFieldInfo?.id } : {}),
        ...(isEdit ? { isExisting: true } : {}),
      }
    })

  const selectedProductType = flyoutProductData?.productDetails?.productType
  const isSubscription = selectedProductType === PlanType.SAAS_SUBSCRIPTION

  const dimensions = flyoutProductData?.productDimensions?.dimensions || []

  const additionalUsageDimensionsList = dimensions.filter(
    (dimension: ContractDimension) =>
      !isSubscription ? dimension.isAdditionalUsageAllowed : true
  )
  const contractDimensionsList = isSubscription
    ? []
    : dimensions.filter(
        (dimension: ContractDimension) => !dimension.isAdditionalUsageAllowed
      )

  const contractDimensionsListWithCheckbox = contractDimensionsList.map(
    (dimension: ContractDimension) => {
      const foundDimension = additionalUsageDimensionsList.find(
        (d: any) => d.name === dimension.name
      )
      return {
        ...dimension,
        checkBoxAdditionalUsageAllowed: !!foundDimension,
        ...(isEdit ? { isExisting: true } : {}),
      }
    }
  )

  const additionalUsageDimensionsListWithCheckbox =
    additionalUsageDimensionsList.map((dimension: ContractDimension) => {
      const foundDimension = contractDimensionsList.find(
        (d: any) => d.name === dimension.name
      )
      return {
        ...dimension,
        checkBoxAdditionalUsageAllowed: !!foundDimension,
        ...(isEdit ? { isExisting: true } : {}),
      }
    })

  const infoCollection = {
    ...(flyoutProductData.infoCollectionFormMetaData || {}),
  }
  const { bgColor, buttonColor, buttonTextColor } =
    flyoutProductData.infoCollectionFormMetaData || {}
  Object.keys(infoCollection).forEach(key => {
    if (
      Object.keys(prePopulatedFieldLandingPage).includes(key) &&
      !infoCollection[key]
    ) {
      infoCollection[key] = prePopulatedFieldLandingPage[key]
    }
  })

  return {
    ...flyoutProductData,
    infoCollectionFormMetaData: {
      ...flyoutProductData.infoCollectionFormMetaData,
      ...infoCollection,
      buyerFormFields: customFields,
      bgColor: convertRGBAAlpha(bgColor),
      buttonColor: convertRGBAAlpha(buttonColor),
      buttonTextColor: convertRGBAAlpha(buttonTextColor),
    },
    ...(!isEdit
      ? {
          agreement: {
            ...(!isEmpty(flyoutProductData?.agreement?.terms)
              ? flyoutProductData?.agreement
              : camelize(flyOutProductAgreementTerms)),
          },
        }
      : {}),
    productDimensions: {
      ...flyoutProductData.productDimensions,
      dimensions: contractDimensionsListWithCheckbox?.length
        ? contractDimensionsListWithCheckbox
        : [PRODUCT_DIMENSIONS_ZERO_VALUE],
      additionalDimensions: additionalUsageDimensionsListWithCheckbox,
    },
    ...(!isEdit
      ? {
          lockMetadata: {
            ...lockMetadata,
          },
        }
      : {}),
  }
}

interface UpdateFlyoutProductProps {
  productForm: FlyoutProductSections
  partnerId: string
  productId?: string
  callBackFlyoutProduct?: () => void
}

export const updateFlyoutProduct =
  ({
    partnerId,
    productForm,
    productId,
    callBackFlyoutProduct,
  }: UpdateFlyoutProductProps) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    const productName =
      productForm?.[FlyoutProductAddEditSectionName?.GENERAL_INFORMATION]?.title

    try {
      await dispatch(startLoading(LoadingTypes.SUBMIT_FLYOUT_PRODUCT_DETAIL))
      const {
        productForm: productFormInfo,
        auditJson,
        ...restInfo
      } = getState()?.flyoutProductInCreation?.currentProductDetail
      const productFormData = getTrimedValueProductForm(productForm)
      const { product_details, ...restProductDetails } = processFlyoutProduct({
        productForm: productFormData,
        productId,
        isEdit: true,
        existingBuyerFormField: productFormInfo?.buyerFormFields,
      })
      const sendProductPayload = {
        audit_json: auditJson,
        ...snakeize(restInfo),
        ...restProductDetails,
        product_name: restProductDetails?.general_information?.title,
      }

      const productPayload = JSON.parse(
        JSON.stringify(sendProductPayload).replaceAll('\\"', '\\\\\\"')
      )

      const response = await patchFlyOutProductFormData({
        data: productPayload,
        partnerId,
        productId,
      })

      if (response) {
        await dispatch(
          setProductDetailFormData({
            ...getState()?.flyoutProductInCreation?.currentProductDetail,
            edit: response?.data?.edit,
            awsChangeSetStatus: response?.data?.awsChangeSetStatus,
            error: response?.data?.error,
            updatedAt: response?.data?.updated_at,
          })
        )

        const successMessage = `Edit request for "${productName}" is in progress`

        await dispatch(
          updateAppAlert({
            message: successMessage,
            messageType: 'SUCCESS',
            autoClose: true,
          })
        )
      }
    } catch (error: any) {
      await dispatch(stopLoading(LoadingTypes.SUBMIT_FLYOUT_PRODUCT_DETAIL))
      const e = error as AxiosError
      const errorResponse = e?.response as AxiosResponse<ErrorResponse>

      dispatch(
        updateAppAlert({
          message: `"${productName}" listing could not be edited. Please try again in some time`,
          messageType: 'ERROR',
          autoClose: true,
        })
      )
      const globalState = getState()
      errorLogger({ globalState })(
        error as Error,
        errorResponse?.data?.track_id
      )
    } finally {
      callBackFlyoutProduct && callBackFlyoutProduct()
      await dispatch(stopLoading(LoadingTypes.SUBMIT_FLYOUT_PRODUCT_DETAIL))
    }
  }

export const clearProductDetail = () => ({
  type: FlyoutProductForm.CLEAR_FLYOUT_PRODUCT_DETAIL_FORM,
})

export const flyoutProductSyncWithAWS =
  ({
    partnerId,
    productId,
    productName,
  }: {
    partnerId: string
    productId: string
    productName: string
  }) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    try {
      await dispatch(startLoading(LoadingTypes.PRODUCT_SYNC_WITH_CLOUD))

      await patchFlyOutProductSync({
        partnerId,
        productId,
      })

      const successMessage = `"${productName}" successfully synced with AWS.`

      await dispatch(
        updateAppAlert({
          message: successMessage,
          messageType: 'SUCCESS',
          autoClose: true,
        })
      )
    } catch (error: any) {
      await dispatch(stopLoading(LoadingTypes.PRODUCT_SYNC_WITH_CLOUD))
      await dispatch(
        updateAppAlert({
          message: `"${productName}" sync failed with AWS. Please try again in some time.`,
          messageType: 'ERROR',
          autoClose: true,
        })
      )

      const e = error as AxiosError
      const errorResponse = e?.response as AxiosResponse<ErrorResponse>

      const globalState = getState()
      errorLogger({ globalState })(
        error as Error,
        errorResponse?.data?.track_id
      )
    } finally {
      await dispatch(stopLoading(LoadingTypes.PRODUCT_SYNC_WITH_CLOUD))
    }
  }

export const getProductInCreationMicrosoft =
  ({ listingType }: { listingType: FlyoutListingProductType }) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    await dispatch(startLoading(LoadingTypes.FLYOUT_PRODUCT_DETAIL))
    try {
      const initialProduct = getInitialProductBasedOnCloud(CloudType.AZURE)
      const filteredMigrationProducts = getState()?.productsListing[
        'AZURE'
      ]?.products?.rows?.filter(
        item => item?.status === ProductStatus.PRODUCT_STATUS_MIGRATION_IN_QUEUE
      )
      let listingJson = {}
      if (filteredMigrationProducts?.length) {
        listingJson = {
          ...getTransformedListingJsonMicrosoft(
            filteredMigrationProducts[0]
              ?.listingData as FlyoutMicrosoftProductSections
          ),
        }
      }
      await dispatch(
        setMicrosoftProductFormData({
          ...initialProduct,
          ...listingJson,
        })
      )
      await dispatch(setProductFormListingType(listingType))
    } catch (error) {
      await dispatch(
        updateAppAlert({
          message: getErrorMessages([RequestFailureMessage])(
            error as AxiosResponse<ErrorResponse>
          ),
          messageType: 'ERROR',
          autoClose: false,
        })
      )
      const globalState = getState()
      errorLogger({ globalState })(error as Error)
    } finally {
      await dispatch(stopLoading(LoadingTypes.FLYOUT_PRODUCT_DETAIL))
    }
  }

export const returnMigrationProductListMicrosoft = ({
  azureProducts,
  migrationProducts,
}: {
  azureProducts: Product[]
  migrationProducts: MigrationProduct[]
}) => {
  const mappedMigrationProducts = migrationProducts
  const selectedProductIds =
    azureProducts
      ?.filter(
        (product: Product) =>
          product.status === ProductStatus.PRODUCT_STATUS_MIGRATION_IN_QUEUE
      )
      .map((product: Product) => product.cloudMarketplaceProductId) || []

  const sortedMigrationProducts = sortProducts(
    selectedProductIds,
    mappedMigrationProducts
  )
  return sortedMigrationProducts
}
const getMicrosoftProductsAndUpdateMigrationProductsList = async (
  partnerId: string,
  dispatch: AppDispatch,
  getState: () => RootState,
  formValues: FlyoutMicrosoftProductSections
) => {
  try {
    await dispatch(getProducts(partnerId, 'AZURE', false))
    const azureProducts = getState()?.productsListing['AZURE']
    const state = getState()
    const migrationProducts =
      state?.flyOutMigrationProductsInfo?.migrationProducts?.products?.rows ||
      []
    const sortedMigrationProducts = returnMigrationProductListMicrosoft({
      azureProducts: azureProducts?.products?.rows,
      migrationProducts,
    })
    let listingJson = {}
    const migrationInQueueProducts = azureProducts?.products?.rows?.filter(
      item => item?.status === ProductStatus.PRODUCT_STATUS_MIGRATION_IN_QUEUE
    )

    if (migrationInQueueProducts?.length) {
      listingJson = {
        ...getTransformedListingJsonMicrosoft(
          migrationInQueueProducts[0]
            ?.listingData as FlyoutMicrosoftProductSections
        ),
      }
    }
    await dispatch(
      setMigrationProductsData({
        ...state?.flyOutMigrationProductsInfo?.migrationProducts,
        products: {
          ...state?.flyOutMigrationProductsInfo?.migrationProducts?.products,
          rows: sortedMigrationProducts,
        },
      })
    )
    if (!isEmpty(listingJson)) {
      await dispatch(
        setMicrosoftProductFormData({
          ...listingJson,
          ...(!migrationInQueueProducts?.length
            ? {
                pageMarker: {
                  ...getState()?.flyoutProductInCreation
                    ?.currentProductInCreation?.microsoftProductForm?.[
                    FlyoutProductAddEditSectionName.PAGE_MARKER
                  ],
                  page1: false,
                },
              }
            : {}),
        })
      )
    } else {
      await dispatch(
        setMicrosoftProductFormData({
          ...formValues,
          ...(!migrationInQueueProducts?.length
            ? {
                pageMarker: {
                  ...getState()?.flyoutProductInCreation
                    ?.currentProductInCreation?.microsoftProductForm?.[
                    FlyoutProductAddEditSectionName.PAGE_MARKER
                  ],
                  page1: false,
                },
              }
            : {}),
        })
      )
    }
  } catch (error) {
    dispatch(
      updateAppAlert({
        message: 'Failed to fetch migration products. Please try again.',
        messageType: 'ERROR',
        autoClose: true,
      })
    )
  }
}
export const saveMicrosoftMigrationProduct =
  ({
    partnerId,
    products,
    isClear,
    isUpdate,
    onSuccess,
  }: {
    partnerId: string
    products: string[]
    isClear?: boolean
    isUpdate?: boolean
    onSuccess?: () => void
  }) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    try {
      if (isClear) {
        await dispatch(startLoading(LoadingTypes.CLEAR_FLYOUT_PRODUCT_DETAIL))
      } else {
        await dispatch(startLoading(LoadingTypes.SUBMIT_FLYOUT_PRODUCT_DETAIL))
      }
      await postPublicProducts({
        data: products,
        partnerId,
      })
      const firstSuccessMsg = `${products?.length} products have been selected successfully.`
      const updateSuccessMsg = `Selection updated to ${products?.length} products successfully.`
      const clearMessage = 'Your listing form has been cleared successfully.'
      await dispatch(
        updateAppAlert({
          message: isClear
            ? clearMessage
            : isUpdate
              ? updateSuccessMsg
              : firstSuccessMsg,
          messageType: 'SUCCESS',
          autoClose: true,
        })
      )
      if (onSuccess) {
        await onSuccess()
      }
    } catch (error: any) {
      const e = error as AxiosError
      const errorResponse = e?.response as AxiosResponse<ErrorResponse>
      dispatch(
        updateAppAlert({
          message: getErrorMessages([RequestFailureMessage])(errorResponse),
          messageType: 'ERROR',
          autoClose: true,
        })
      )
      const globalState = getState()
      errorLogger({ globalState })(
        error as Error,
        errorResponse?.data?.track_id
      )
    } finally {
      if (isClear) {
        await dispatch(stopLoading(LoadingTypes.CLEAR_FLYOUT_PRODUCT_DETAIL))
      } else {
        await dispatch(stopLoading(LoadingTypes.SUBMIT_FLYOUT_PRODUCT_DETAIL))
      }
    }
  }

export const sortProducts = (
  selectedProductIds: string[],
  productsMappingDataObjects: MigrationProduct[]
): MigrationProduct[] => {
  let sortedProducts: MigrationProduct[] = []

  if (selectedProductIds?.length > 0) {
    sortedProducts = [
      ...selectedProductIds
        ?.map(
          id =>
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            productsMappingDataObjects.find(product =>
              product.id?.includes(id)
            )!
        )
        .filter(Boolean),
      ...productsMappingDataObjects.filter(
        product =>
          product.id &&
          !selectedProductIds?.includes(product.id) &&
          !selectedProductIds?.includes(product.id?.split('/')[1])
      ),
    ]
  } else {
    sortedProducts = [...productsMappingDataObjects]
  }

  return sortedProducts
}

export const sendMicrosoftProduct =
  ({
    partnerId,
    formValues,
    isDraft,
    isFetch,
    handleSuccess,
    isClear,
    isImPartner = false,
  }: {
    partnerId: string
    formValues: FlyoutMicrosoftProductSections
    isDraft?: boolean
    isFetch?: boolean
    isClear?: boolean
    handleSuccess?: () => void
    isImPartner?: boolean
  }) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    try {
      if (isClear) {
        await dispatch(startLoading(LoadingTypes.CLEAR_FLYOUT_PRODUCT_DETAIL))
      } else {
        await dispatch(startLoading(LoadingTypes.SUBMIT_FLYOUT_PRODUCT_DETAIL))
      }
      const payloadSendData = transformedProductForSend({ formValues })
      await postMicrosoftProduct({
        data: {
          listing_data: payloadSendData,
          status: isDraft ? 'DRAFT' : 'SUBMIT',
          ...(isImPartner ? { switch_landing_page: false } : {}),
        },
        partnerId,
      })

      const clearMessage = 'Your listing form has been cleared successfully.'
      await dispatch(
        updateAppAlert({
          message: isClear
            ? clearMessage
            : isDraft
              ? ''
              : 'product migrated successfully',
          messageType: 'SUCCESS',
          autoClose: true,
        })
      )
      if (handleSuccess) {
        handleSuccess()
      }
      if (isFetch) {
        await getMicrosoftProductsAndUpdateMigrationProductsList(
          partnerId,
          dispatch,
          getState,
          formValues
        )
      }
    } catch (error: any) {
      const e = error as AxiosError
      const errorResponse = e?.response as AxiosResponse<ErrorResponse>
      dispatch(
        updateAppAlert({
          message: getErrorMessages([RequestFailureMessage])(errorResponse),
          messageType: 'ERROR',
          autoClose: true,
        })
      )
      const globalState = getState()
      errorLogger({ globalState })(
        error as Error,
        errorResponse?.data?.track_id
      )
    } finally {
      if (isClear) {
        await dispatch(stopLoading(LoadingTypes.CLEAR_FLYOUT_PRODUCT_DETAIL))
      } else {
        await dispatch(stopLoading(LoadingTypes.SUBMIT_FLYOUT_PRODUCT_DETAIL))
      }
    }
  }

export const transformedProductForSend = ({
  formValues,
}: {
  formValues: FlyoutMicrosoftProductSections
}) => {
  const {
    bgColor,
    buttonColor,
    buttonTextColor,
    buyerFormFields,
    ...restInfoCollectionData
  } = formValues[FlyoutProductAddEditSectionName.LANDING_PAGE_DETAILS]
  const buyerFormFieldsData = arrayFieldValueTrim(buyerFormFields || [], [
    'title',
  ])
  const transformedBuyerField = buyerFormFieldsData?.reduce(
    (acc, field, index) => {
      const {
        title,
        displayOrder,
        dataType,
        isRequired,
        validationType,
        minLength,
        maxLength,
        id,
      } = field

      const initialLength = formValues?.buyerFormFields
        ? Object.values(formValues?.buyerFormFields).filter(
            item => !item.isCustom
          ).length
        : 3
      const formatTitle = returnTrimedValue(title).toLowerCase()
      const key = camelize(formatTitle.replace(/ /g, '_'))
      acc[key] = {
        title: formatTitle,
        displayOrder: initialLength + index + 1,
        placeHolder: formatTitle,
        dataType,
        isCustom: true,
        isRequired,
        validationType,
        maxLength,
        minLength,
        ...(id ? { id: id, displayOrder: displayOrder } : {}),
      }
      return acc
    },
    {} as Record<string, BuyerFormFieldsBackend>
  )

  let updatedNotificationRecipients = {}
  Object.keys(formValues?.notificationRecipients).forEach(keyName => {
    const kebabCaseKeyName = convertToKebabCase(keyName)
    updatedNotificationRecipients = {
      ...updatedNotificationRecipients,
      [kebabCaseKeyName]:
        formValues?.notificationRecipients[
          keyName as string as keyof NotificationRecipients
        ],
    }
  })

  return {
    ...snakeize(formValues),
    general_information: {
      ...snakeize(formValues?.generalInformation),
    },
    info_collection_form_meta_data: snakeize({
      ...restInfoCollectionData,
      bgColor: convertRGBAAlpha(bgColor, true),
      buttonColor: convertRGBAAlpha(buttonColor, true),
      buttonTextColor: convertRGBAAlpha(buttonTextColor, true),
    }),
    buyer_form_fields: snakeize({
      ...(initialMSFTPoduct?.buyerFormFields || {}),
      ...transformedBuyerField,
    }),
    notification_recipients: {
      ...updatedNotificationRecipients,
    },
  }
}

export const getTransformedListingJsonMicrosoft = (
  formValues?: FlyoutMicrosoftProductSections
) => {
  if (!formValues) return {}
  const { buyerFormFields = {} } = formValues
  const excludedFields = ['email', 'firstName', 'companyName']
  const customFields = Object.keys(buyerFormFields || {})
    .filter(
      fieldName =>
        typeof buyerFormFields[fieldName] === 'object' &&
        buyerFormFields[fieldName] !== null &&
        !excludedFields.includes(fieldName) &&
        buyerFormFields[fieldName]?.isCustom
    )
    .map(fieldName => {
      const typedFieldInfo = buyerFormFields[
        fieldName
      ] as FlyoutProductBuyerFormFields
      return {
        title: typedFieldInfo?.title,
        displayOrder: typedFieldInfo?.displayOrder,
        dataType: typedFieldInfo?.dataType,
        isRequired: typedFieldInfo?.isRequired,
        validationType: typedFieldInfo?.validationType,
        minLength: typedFieldInfo?.minLength,
        maxLength: typedFieldInfo?.maxLength,
        ...(typedFieldInfo?.id ? { id: typedFieldInfo?.id } : {}),
      }
    })

  const infoCollection: Record<string, any> = {
    ...(formValues.infoCollectionFormMetaData || {}),
  }
  const { bgColor, buttonColor, buttonTextColor } =
    formValues.infoCollectionFormMetaData || {}
  Object.keys(infoCollection).forEach(key => {
    if (
      Object.keys(prePopulatedFieldLandingPage).includes(key) &&
      !infoCollection[key]
    ) {
      infoCollection[key] = prePopulatedFieldLandingPage[key]
    }
  })

  return {
    ...formValues,
    infoCollectionFormMetaData: {
      ...formValues.infoCollectionFormMetaData,
      ...infoCollection,
      buyerFormFields: customFields,
      bgColor: convertRGBAAlpha(bgColor),
      buttonColor: convertRGBAAlpha(buttonColor),
      buttonTextColor: convertRGBAAlpha(buttonTextColor),
    },
  }
}
